import StoreListPage from "@/pages/StoreListPage.vue";
import StoreHoursWidget from "@/pages/StoreHoursWidget.vue";
import ProductListPage from "@/pages/ProductListPage.vue";
//import ProductPriceMapWidget from "@/pages/ProductPriceMapWidget.vue";
//import ProductPriceHistogramWidget from "@/pages/ProductPriceHistogramWidget.vue";
import {defineAndRegisterElement} from "@/register.ts";

import "./assets/styles.scss"; // Global component styles

defineAndRegisterElement('store-list-page', StoreListPage)
defineAndRegisterElement('store-hours-widget', StoreHoursWidget)

defineAndRegisterElement('product-list-page', ProductListPage)
//defineAndRegisterElement('product-price-map-widget', ProductPriceMapWidget)
//defineAndRegisterElement('product-price-histogram-widget', ProductPriceHistogramWidget)
